export function hasCustomScheme() {
    return true;
}
export function collectManifestSchemes() {
    return [];
}
export function hasConstantsManifest() {
    return false;
}
export function resolveScheme() {
    return 'https';
}
//# sourceMappingURL=Schemes.web.js.map